
/**
 * Wandelt einen einen Datumsstring ohne Punkte (14011996) in einen mit Punkten (14.01.1996) um.
 * Anwendbar auf Inputfelder: $inputFeld.stringToDate();
 *
 * Autor: Lion Cassens
 */

String.prototype.insertAt=function (index, string) {
  return this.substr(0, index) + string + this.substr(index);
};

$.fn.stringToDate = function () {
  this.change(function () {
    $(this).val(stringToDate(this.value));
  });
};

function stringToDate(str) {
  if (str.length != 8 || $.isNumeric(str) == false) {
    return str;
  }

  str = str.insertAt(2, '.');
  str = str.insertAt(5, '.');

  return str;
}
